const inrFmt = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

/** Whole rupees for display; pass fraction if you switch maximumFractionDigits. */
export function formatInr(value) {
  const n = Number(value);
  if (Number.isNaN(n)) return inrFmt.format(0);
  return inrFmt.format(Math.round(n));
}
